import { deleteDocument } from "../api";
import { showToast } from "@/modules/common/utils";
import { TOAST_IDS, ToastType } from "@/modules/common/types";
import { queryClient } from "@/queryClient";
import { useDomainMutation } from "@/modules/common/hooks/domain-mutation.hook";

const useDeleteDocument = () => {
  const mutation = useDomainMutation({
    mutationFn: (documentId: string) => deleteDocument(documentId),
    onSuccess: () => {
      showToast({
        type: ToastType.SUCCESS,
        message: "Document deleted successfully",
        toastId: TOAST_IDS.DELETE_DOCUMENT_SUCCESS,
      });
      queryClient.invalidateQueries({ queryKey: ["track-documents"] });
    },
    onError: () => {
      showToast({
        type: ToastType.ERROR,
        message: "Failed to delete document",
        toastId: TOAST_IDS.DELETE_DOCUMENT_ERROR,
        options: {
          position: "bottom-left",
          autoClose: 3000,
        },
      });
    },
  });

  return {
    deleteDocument: mutation.mutate,
    isDeleting: mutation.isPending,
  };
};

export default useDeleteDocument;
